import { GzCardWebComponent } from './component/GzCardWebComponent';
import { WEB_COMPONENT_GZ_CARD } from '../../webcomponents.constants';

export { GzCardWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_CARD, GzCardWebComponent);
